
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.7991 4H13.2016C13.2575 4.00544 13.3135 4.01473 13.3695 4.01541C15.0574 4.03603 16.7454 4.0664 18.4294 4.18652C19.159 4.23864 19.8914 4.29756 20.6114 4.41926C21.8257 4.62436 22.6246 5.34459 22.9523 6.5353C23.0837 7.01258 23.1499 7.51116 23.2104 8.00431C23.3516 9.15558 23.4017 10.3139 23.4207 11.4731C23.4397 12.6327 23.3992 13.791 23.3119 14.9475C23.2537 15.7192 23.1741 16.4882 23.0126 17.2462C22.7979 18.2531 22.2357 18.9818 21.2856 19.3963C20.8829 19.5719 20.451 19.6367 20.0197 19.675C19.1175 19.7552 18.2146 19.8361 17.3101 19.8763C16.0843 19.9304 14.8569 19.9461 13.6301 19.9794C13.4871 19.9832 13.3446 19.993 13.2016 20H10.7991C10.7544 19.9948 10.7098 19.9855 10.6651 19.9848C8.8487 19.9633 7.03272 19.925 5.22082 19.7906C4.60824 19.745 3.99408 19.6848 3.38898 19.5821C2.28054 19.394 1.49844 18.7667 1.12337 17.7009C0.972211 17.2712 0.899916 16.8086 0.835554 16.3547C0.657877 15.101 0.602806 13.8371 0.580143 12.572C0.559067 11.3933 0.600086 10.2162 0.689152 9.04091C0.747395 8.27286 0.828982 7.50844 0.987169 6.75331C1.1347 6.04827 1.46898 5.45813 2.03419 5.00329C2.5151 4.61643 3.07805 4.44623 3.67793 4.36261C4.68122 4.22278 5.6913 4.16023 6.70184 4.12147C7.96575 4.07297 9.23079 4.0519 10.4954 4.01813C10.5967 4.01541 10.6978 4.00635 10.7991 4ZM15.6603 12.0002C13.6652 10.849 11.6947 9.71196 9.71805 8.57111V15.4293C11.7006 14.2853 13.6695 13.1492 15.6603 12.0002Z","fill":"#16171F"}})])
          )
        }
      }
    